import { SpacerSpacing } from '@ampcore/adel-react'

import { CarouselBackgroundColor } from './CarouselColor.type'

/**
 * - `COMPLEX`: slides laid out as columns (image + rich content), with a
 *   configurable background, optional intro block and full-bleed support.
 * - `LEGACY`: each slide stacks a heading and body above a full-width image,
 *   on the brand background with reversed contrast and a full-bleed band.
 */
export enum CarouselVariant {
  COMPLEX = 'complex',
  LEGACY = 'legacy'
}

/**
 * Content column's share of a two-column slide; the image takes the remainder.
 * `7525` is content three-quarters / image one-quarter; `2575` is the inverse.
 */
export type CarouselSlideRatio = '5050' | '7525' | '2575'

export type CarouselSlide = {
  title?: string
  imageSrc?: string
  /** Empty string marks the image decorative. */
  imageAlt?: string
  /** Rich HTML, sanitized before rendering. */
  content?: string
  /** Defaults to `right` (content first, image second). */
  imagePosition?: 'left' | 'right'
  /** Defaults to `5050`. */
  ratio?: CarouselSlideRatio
}

export type CarouselProps = {
  title?: string
  /** Rich HTML, sanitized before rendering, shown above the carousel. */
  introductionContent?: string
  /** A single slide is normalized to a one-item array. */
  slideList?: CarouselSlide | CarouselSlide[]
  /**
   * The component derives the fill and contrast classes from this value.
   * Unrecognized values resolve to white/brand.
   */
  backgroundColor?: CarouselBackgroundColor
  isFullBleed?: boolean
  /** Omitted: non-full-bleed defaults to `full`, full-bleed to no margin. */
  componentSpacing?: SpacerSpacing
  /** Defaults to `true`. */
  loop?: boolean
  variant?: CarouselVariant
  leftArrowDataAnalytics?: string
  rightArrowDataAnalytics?: string
  /** Prefix for `data-testid` hooks on sub-elements. */
  testId?: string
}
